let VOWELS = ['a', 'e', 'i', 'o', 'u'];

export let getPluralFromSingular = (singular: string): string => {
  if (['ch', 'sh'].includes(singular.slice(-2))) return singular + 'es';

  if (['s', 'x', 'z'].includes(singular.slice(-1))) return singular + 'es';

  if (VOWELS.includes(singular.slice(-2, -1)) && singular.slice(-1) === 'y')
    return singular + 's';

  if (!VOWELS.includes(singular.slice(-2, -1)) && singular.slice(-1) === 'y')
    return singular.slice(0, singular.length - 1) + 'ies';

  if (singular.slice(-1) === 'f')
    return singular.slice(0, singular.length - 1) + 'ves';

  if (singular.slice(-2) === 'fe')
    return singular.slice(0, singular.length - 2) + 'ves';

  if (!VOWELS.includes(singular.slice(-2, -1)) && singular.slice(-1) === 'o')
    return singular + 'es';

  return singular + 's';
};

/**
 * Utility for reporting counts, which manages pluralization based on count.
 *
 * @param {Object} args The main arguments object.
 * @param {number} [args.count=0] The number of args.noun
 * @param {string} args.singular A singular noun, will be automatically pluralized when necessary.
 * @param {string} [args.plural] Manually supply the plural version of the noun.
 * @param {string} [args.hideCount=false] Return only the noun, no count
 *
 * @returns {String} Returns a formatted string.
 *
 * @example
 *
 * pluralize({ count: 1, singular: 'loan' })
 * // => 1 loan
 *
 */

export let pluralize = ({
  count = 0,
  singular,
  plural = '',
  hideCount = false,
}: {
  count: number;
  singular: string;
  plural?: string;
  hideCount?: boolean;
}): string => {
  let finalNoun = (() => {
    let isPlural = count !== 1;

    if (isPlural) return plural || getPluralFromSingular(singular);
    else return singular;
  })();

  if (hideCount) return finalNoun;

  return `${count} ${finalNoun}`;
};
